export default "__VITE_ASSET__DgA7cjkT__ 720w";